import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class SourceOfIncome extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get header() {
    return get(this, '_naglowek.value', '');
  }

  get icon() {
    return get(this, '_ikonka.value[0].url', '');
  }

  get text() {
    return get(this, '_tekst.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/SourceOfIncome.js